// var verticle_slide = new Swiper(".slider-verticle", {
//   direction: "vertical",
//   spaceBetween: 30,
//   loop: true,
//   allowTouchMove: false,
//   autoplay: {
//     delay: 0,
//   },
//   slidesPerView: 1,
//   speed: 5000,
//   breakpoint: {
//     769: {
//       direction: "horizontal",
//     },
//   },
// });

// var verticle_slide_reverse = new Swiper(".slider-verticle-prev", {
//   direction: "vertical",
//   allowTouchMove: false,
//   spaceBetween: 30,
//   loop: true,
//   autoplay: {
//     delay: 0,
//     reverseDirection: true,
//   },
//   slidesPerView: 1,
//   speed: 5000,
//   breakpoint: {
//     769: {
//       direction: "horizontal",
//     },
//   },
// });



var verticle_slide = new Swiper(".slider-verticle", {
  direction: "vertical",
  spaceBetween: 30,
  loop: true,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
  slidesPerView: 1,
  speed: 5000,
  breakpoints: {
    0: {
      direction: "horizontal",
      spaceBetween: 15,
    },
    768: { // For screens less than 749px, switch to horizontal
       direction: "horizontal",
    },
    769: {
       direction: "vertical",
    }
  },
});

var verticle_slide_reverse = new Swiper(".slider-verticle-prev", {
  direction: "vertical",
  allowTouchMove: false,
  spaceBetween: 30,
  loop: true,
  autoplay: {
    delay: 0,
    reverseDirection: true,
  },
  slidesPerView: 1,
  speed: 5000,
  breakpoints: {
    0: {
      direction: "horizontal",
      spaceBetween: 15,  
    },
    768: { // For screens less than 749px, switch to horizontal
       direction: "horizontal",
    },
    769: {
       direction: "vertical",
    }
    
  },
});
